<template>
  <div>
    <div class="app-top">
      <div class="container">
        <h1>{{this.form.paymentNo?'订单详情':'订单确认'}}</h1>
        <div class="row">
          <!-- 左侧 -->
          <div class="col-12 col-sm-8">
            <div class="container-left box">
              <!-- ================================================网络版================================================== -->
              <div>
                <!-- ====================================购买套餐==================================== -->
                <h2>短信套餐</h2>
                <div class="box-info">
                  <div>
                    <label>套餐名称：</label>
                    <span class="box-value">{{form.name}}</span>
                  </div>
                  <div>
                    <label>短信数量：</label>
                    <span class="box-value">{{form.count}}条</span>
                  </div>
                  <div>
                    <label>套餐金额：</label>
                    <span class="box-value" style="color: red;">{{form.amount.toFixed(2)}}</span>
                  </div>
                  <!-- <div>
                    <label>有效期限：</label>
                    <span class="box-value">{{form.validTime}}</span>
                  </div>-->
                </div>

                <!-- ====================================提示==================================== -->
                <div class="box-info" style="color: #999;">
                  <p>套餐包购买成功后即刻生效，到期后未使用余量自动过期，套餐包不支持续期，套餐包购买后不支持退订，当前套餐有效期限为{{form.validTime}}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 右侧 -->
          <div class="col-12 col-sm-4">
            <div class="container-right box">
              <div class="box-info">
                <div>
                  <label>订单编号：</label>
                  <span>{{form.no}}</span>
                </div>
                <div>
                  <label>订单金额：</label>
                  <span style="color:red;font-size:22px;">￥{{form.amount.toFixed(2)}}</span>
                </div>
              </div>
              <hr />
              <div v-if="amountTimeout">请重新提交订单</div>
              <div v-else-if="form.paymentNo" class="box-pay-success">已完成</div>
              <div v-else>
                <div class="row box-pay">
                  <div class="col" @click="paymode = 'weixin'">
                    <div :class="['paymode',paymode == 'weixin' ? 'paymode-active' : '']">
                      <img src="@/assets/images/icon/wx1.png" alt />
                      <span>微信</span>
                    </div>
                  </div>
                  <div class="col" @click="paymode = 'alipay'">
                    <div :class="['paymode',paymode == 'alipay' ? 'paymode-active' : '']">
                      <img src="@/assets/images/icon/zfb1.png" alt />
                      <span>支付宝</span>
                    </div>
                  </div>
                </div>
                <div style="margin:20px 0;">
                  <button type="button" class="btn btn-danger" style="width:100%" @click="handleSave">支付</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="微信支付" :visible.sync="dialogVisible" @close="dialogClose" width="300px">
      <div style="width: 100%; display: flex; justify-content: center;">
        <div style="border:1px solid #ddd;padding:10px">
          <div ref="qrCodeUrl"></div>
        </div>
      </div>
      <div style="text-align:center;margin-top:10px;">打开微信，扫码支付</div>
      <div style="text-align:center;margin-top:10px; font-size: 18px; color: red;font-weight: bold;">￥{{form.amount.toFixed(2)}}</div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api/sms'
import QRCode from 'qrcodejs2'

export default {
  name: 'SmsOrderConfirm',
  data() {
    return {
      form: {
        no: '',
        amount: 0
      },
      paymode: 'weixin',
      timer: null,
      timeCount: 0,
      dialogVisible: false,
      text: '',
      amountTimeout: false
    }
  },
  watch: {},
  computed: {
    title() {
      if (this.form.paymentNo) {
        return '订单详情'
      } else {
        return '订单确认'
      }
    }
  },
  created() {
    console.log(this.$route.query)
    this.form.no = this.$route.query.no
    if (this.form.no) {
      this.getOne()
    }
  },
  methods: {
    getOne() {
      API.orderGetOne({ no: this.form.no }).then(res => {
        this.form = res.data
      })
    },
    handleSave() {
      if (this.paymode === 'alipay') {
        this.$Message({
          showClose: true,
          message: '支付宝暂不支持，请使用微信支付。',
          type: 'error'
        })
        return false
      }
      API.wxPayQrCode({ type: 'smsOrder', no: this.form.no }).then(res => {
        console.log(res)
        // this.$bvModal.show('exampleModalCenterTitle')
        this.dialogVisible = true
        this.text = res.data
        this.$nextTick(() => {
          //生成二维码的方法
          this.creatQrCode()
        })
        this.timeCount = 100
        this.setTimer()
      })
    },
    creatQrCode() {
      this.$refs.qrCodeUrl.innerHTML = ''
      new QRCode(this.$refs.qrCodeUrl, {
        text: this.text, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: '#000000', //二维码颜色
        colorLight: '#ffffff' //二维码背景色
      })
    },
    setTimer() {
      this.timer = setTimeout(() => {
        if (this.timeCount > 0) {
          API.orderGetOne({ no: this.form.no })
            .then(res => {
              console.log(res)
              this.timeCount--
              if (res.data.paymentNo) {
                clearTimeout(this.timer)
                this.form = res.data
                this.$msgbox.alert('支付成功', '信息', {
                  confirmButtonText: '确定',
                  callback: () => {
                    this.dialogVisible = false
                  }
                })
              } else {
                this.setTimer()
              }
            })
            .catch(() => {
              this.timeCount--
              this.setTimer()
            })
        } else {
          clearTimeout(this.timer)
          this.$msgbox.alert('支付连接超时请重新支付', '信息', {
            confirmButtonText: '确定',
            callback: () => {
              this.dialogVisible = false
            }
          })
        }
      }, 3000)
    },
    dialogClose() {
      clearTimeout(this.timer)
    }
  },
  beforeRouteLeave(to, form, next) {
    clearTimeout(this.timer)
    next()
  }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 576px) {
  h1 {
    padding: 5px 0 -15px 10px !important;
    font-size: 18px !important;
  }
  .box {
    padding-bottom: 5px !important;
    margin: 5px 0 5px 0 !important;
    h2 {
      font-size: 16px !important;
      margin-bottom: 10px !important;
    }
    .box-info {
      font-size: 14px !important;
      margin-bottom: 15px !important;
    }
  }
}

// 结束
.app-top {
  margin-top: 58px;
  min-height: calc(100vh - 370px);
  position: relative;
  background: #f8f8f8;
}
h1 {
  padding: 20px 0 0 20px;
  font-size: 24px;
  color: #333;
}

.box {
  color: #888;
  background: #ffffff;
  margin: 10px 0 30px 0;
  padding: 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.07);
  // box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border-top: #ddd 3px solid;
  h2 {
    font-size: 18px;
    color: #333;
    margin-bottom: 20px;
  }
  .box-info {
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 22px;
    padding-left: 10px;
    label {
      width: 70px;
      text-align: right;
    }
    .box-value {
      color: #333;
    }
  }
  .box-pay {
    display: flex;
    align-items: center;

    .paymode {
      margin-top: 10px;
      text-align: center;
      border: 1px solid #eee;
      cursor: pointer;
      // border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 0;
      img {
        width: 32px;
        height: 32px;
        margin-right: 10px;
      }
    }
    .paymode:hover {
      background: #f8f8f8;
    }
    .paymode-active {
      position: relative;
      border: 1px solid #eee;
    }
    .paymode-active:after {
      position: absolute;
      content: '';
      width: 30px;
      height: 30px;
      right: 0;
      bottom: 0;
      background: url('../../assets/images/icon/selected_60.png') no-repeat;
      background-size: cover;
      z-index: 5;
    }
    .free-style {
      font-size: 14px;
      color: rgb(253, 13, 13);
    }
  }
  .box-pay-success {
    text-align: right;
    color: #999;
  }
}

.title {
  display: flex;
  align-items: center;
  h3 {
    font-size: 20px;
    margin-left: 10px;
  }
  img {
    width: 32px;
  }
  .tag {
    padding: 2px 5px;
    font-size: 18px;
    font-weight: lighter;
    color: #000;
    background: #fff;
    border: 1px #ddd solid;
    border-radius: 5px;
    margin-left: 10px;
  }
}

.wrap-qrcode {
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .mask {
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0, 0.5);
    position: absolute;
    z-index: -1;
  }
  .Qrcode {
    width: 320px;
    height: 320px;
    border-radius: 10px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .cose {
    margin-top: 20px;
    width: 50px;
    height: 50px;
    background: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    cursor: pointer;
  }
}
</style>